import { Link } from "react-router-dom";

import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import styled from "styled-components";

import Chip from "@mui/material/Chip";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import LaunchIcon from "@mui/icons-material/Launch";

import {
  Finding,
  FindingSeverity,
  FindingSeverityColor,
  FindingSeverityLabel,
} from "stores/FindingStore";

// -----------------------------------------------------------------------------

export const FindingsColumns = [
  {
    field: "severity",
    headerName: "Severity",
    width: 100,
    flex: 0,
    renderCell: (params: any) => {
      const severity: FindingSeverity = params.row.severity;
      const label: string = FindingSeverityLabel[severity];
      const color: any = FindingSeverityColor[severity];

      //
      return (
        <Chip
          label={label}
          color={color}
          variant="filled"
          sx={{ fontWeight: "bold" }}
          size="small"
        />
      );
    },
  },
  {
    field: "asset",
    headerName: "Asset Name",
    flex: 1,
    renderCell: (params: any) =>
      params.row.details.asset?.name || (
        <Typography variant="inherit" noWrap>
          {params.row.asset}
        </Typography>
      ),
  },
  {
    field: "name",
    headerName: "Link to Finding",
    flex: 1,
    renderCell: (params: GridRenderCellParams<string, Finding>) => (
      <Link
        to={`/organization/findings?finding=${params.row.uuid}`}
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          textDecoration: "none",
          color: "#1F6BBC",
        }}
        target="_blank"
      >
        <Typography variant="inherit" noWrap>
          {params.value}
        </Typography>
        <LaunchIcon sx={{ opacity: 0.5, width: 22 }} />
      </Link>
    ),
  },
];

export const FindingsColumnsLoading = [
  {
    field: "severity",
    headerName: "Severity",
    flex: 1,
    renderCell: RenderSkeleton,
  },
  {
    field: "asset",
    headerName: "Asset",
    flex: 1,
    renderCell: RenderSkeleton,
  },
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    renderCell: RenderSkeleton,
  },
];

function RenderSkeleton() {
  return <SkeletonStyled />;
}

export const LoadingRows: any[] = [
  { uuid: 1 },
  { uuid: 2 },
  { uuid: 3 },
  { uuid: 4 },
  { uuid: 5 },
  { uuid: 6 },
  { uuid: 7 },
  { uuid: 8 },
  { uuid: 9 },
  { uuid: 10 },
];

// -----------------------------------------------------------------------------

export const PaperStyle = {
  p: 0,
  width: "100%",
  height: "100%",
  minHeight: 512,
};

export const DataGridStyle = {
  border: 0,

  "& .MuiTablePagination-displayedRows": {
    lineHeight: "1 !important",
    margin: 0,
  },

  "& .MuiDataGrid-cell": {
    wordBreak: "break-all",
    justifyContent: "space-between",

    "&:focus": {
      outline: "none",
    },
  },

  "& .MuiDataGrid-columnHeaderTitleContainer": {
    padding: 0,
  },

  "& .MuiDataGrid-columnSeparator": {
    display: "none !important",
  },

  "& .arrow-cell": {
    minWidth: "32px !important",
    justifyContent: "center",
    width: "32px !important",
  },

  "& code": {
    width: "auto",
  },
};

// -----------------------------------------------------------------------------

const SkeletonStyled = styled(Skeleton)`
  width: 100%;
`;
